import { useIntl } from 'react-intl'

import EmptyListing from 'app/assets/icons/profile/my-listing.svg'
import EmptyState from 'app/components/common/EmptyState'

const SearchEmptyState = () => {
  const { formatMessage } = useIntl()

  return (
    <EmptyState
      image={<EmptyListing width={64} height={64} />}
      text={formatMessage({
        defaultMessage: 'No results found'
      })}
      hideButton
    />
  )
}

export default SearchEmptyState
